import React from 'react';

import { useGoogleLogin } from '../../hooks/useGoogleLogin';

import { GoogleLogin } from '@react-oauth/google';

const GoogleLoginButton = () => {
  const { mutateAsync: sendToken, isLoading } = useGoogleLogin();
  console.log('GoogleLoginButton', isLoading);

  return (
    <GoogleLogin disabled={isLoading} ux_mode='popup' onSuccess={(r) => sendToken(r.credential)} />
  );
};

export default GoogleLoginButton;
